import PropTypes from 'prop-types'
export default function StarPlusIcon(props) {
  const { color = '#ffffff' } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className="w-16 h-16"
    >
      <path
        fill={color}
        d="M17.053 2.026a.336.336 0 1 0-.671 0v1.031h-1.028a.336.336 0 0 0 0 .674h1.028v1.031a.336.336 0 1 0 .671 0V3.731h1.028a.336.336 0 0 0 0-.674h-1.028V2.026zM2.624 14.149a.336.336 0 1 0-.672 0v1.622H.336a.336.336 0 0 0 0 .674h1.616v1.622a.336.336 0 1 0 .672 0v-1.622H4.24a.336.336 0 0 0 0-.674H2.624V14.15zM4.58 7.794.649 9.374a.674.674 0 0 0 0 1.251l3.93 1.58a5.12 5.12 0 0 1 2.75 2.63l2.174 4.772a.67.67 0 0 0 1.22 0l2.176-4.772a5.12 5.12 0 0 1 2.748-2.63l3.931-1.58a.675.675 0 0 0 0-1.25l-3.93-1.58a5.12 5.12 0 0 1-2.75-2.63L10.725.393a.67.67 0 0 0-1.22 0L7.327 5.165a5.12 5.12 0 0 1-2.748 2.63z"
      />
    </svg>
  )
}

StarPlusIcon.propTypes = {
  color: PropTypes.string,
}
